(function () {
  'use strict';

  angular.module('app').service('CreditPaymentTermModalService', CreditPaymentTermModalService);

  CreditPaymentTermModalService.$inject = ['ModalService'];

  function CreditPaymentTermModalService(ModalService) {
    var service = {
      openCreditPaymentTermsModal: openCreditPaymentTermsModal,
    };

    return service;

    ////////////////

    function openCreditPaymentTermsModal(creditPaymentTerms, companyId, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/credit-payment-terms/modals/credit-payment-term-list-modal.html',
        controller: CreditPaymentTermListModalCtrl,
        controllerAs: 'vm',
        inputs: {
          creditPaymentTerms: creditPaymentTerms,
          companyId: companyId,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          successCallback();
        });
      });
    }

    function CreditPaymentTermListModalCtrl(creditPaymentTerms, companyId, UtilService) {
      var vm = this;

      var utils = new UtilService(vm);

      vm.creditPaymentTerms = creditPaymentTerms;
      vm.companyId = companyId;

      // Methods
      vm.addCreditPaymentTerm = addCreditPaymentTerm;
      vm.cancel = cancel;
      vm.onShowCreditPaymentTerm = onShowCreditPaymentTerm;
      //vm.onPaymentTermStatusChanged = onPaymentTermStatusChanged;
      // vm.onPaymentTermDeleted = onPaymentTermDeleted;

      vm.onCreditPaymentTermSaved = onCreditPaymentTermSaved;
      vm.onCreditPaymentTermCanceled = onCreditPaymentTermCanceled;

      // Initializers
      setDefaults();

      function setDefaults() {
        vm.listMode = true;
        vm.modalTitle = 'CREDIT_PAYMENT_TERMS';
      }

      // List actions
      function addCreditPaymentTerm() {
        vm.listMode = false;

        vm.modalTitle = 'NEW_PAYMENT_TERM';
        vm.item = {};
        vm.originalItem = angular.copy(vm.item);

        vm.mode = 'create';
      }

      function cancel() {
        setDefaults();
      }

      function onShowCreditPaymentTerm(item) {
        vm.listMode = false;
        vm.modalTitle = 'PAYMENT_TERM_DETAILS';

        vm.item = item;
        vm.originalItem = angular.copy(item);

        vm.mode = 'view';
      }

      /*function onPaymentTermStatusChanged(data){
                vm.creditPaymentTerms = data;
                successCallback(vm.creditPaymentTerms);
            }*/

      /* function onPaymentTermDeleted(data){
                vm.creditPaymentTerms = data;
                successCallback(vm.creditPaymentTerms);
            }*/

      // Detail actions
      function onCreditPaymentTermSaved(data, mode) {
        if (mode === 'create') {
          // append only new items
          vm.creditPaymentTerms.push(data);
        } else {
          vm.item.name = data.name;
          vm.item.days = data.days;
        }

        utils.itemListChanged(data.id);

        // successCallback(vm.creditPaymentTerms);
        setDefaults();
      }

      function onCreditPaymentTermCanceled() {
        vm.listMode = true;
      }
    }
  }
})();
